import './styles.scss'
import * as React from "react";
import {Outlet} from "react-router-dom";
import {VeboxDrawer} from "../../../users/components/VeboxDrawer";
import {getFormattedDate} from "../../../ReadAndWrite/ReadAndWrite/utils";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {CensusExport} from "../../widgets/CensusExport";
import {CensusLabelValue} from "../../components/CensusLabelValue";
import {CensusCharts} from "../../widgets/CensusCharts";
import {VeBoxBlackNavBar, VeBoxTab} from "../../../components/VeBoxBlackNavBar";
import {Display} from "../../../components/Display";
import {CensusFinalEquipmentList} from "../../widgets/CensusFinalEquipmentList";
import {CensusDetailsContext} from "../../providers/CensusDetailsProvider";
import {delay} from "@vebox/etui-core";

declare var AppTranslations: AppTranslations;

interface CensusDetailsProps {
}

export enum CENSUS_DETAILS_PAGE {
    SUMMARY = "summary",
    EQUIPMENT = "equipment",
}

export const CensusDetails: React.FC<CensusDetailsProps> = () => {
    const censusTranslations = AppTranslations.massiveActions.censusCooler;
    const {censusDetail, censusGuid, updateLastUserPosition, lastUIUserPosition} = React.useContext(
        CensusDetailsContext)
    const {data, isLoading, error} = censusDetail;

    const [currentPage, setCurrentPage] = React.useState<CENSUS_DETAILS_PAGE>(
        lastUIUserPosition?.detailPage ?? CENSUS_DETAILS_PAGE.SUMMARY);
    const [isDrawerOpen, setIsDrawerOpen] = React.useState<boolean>(false);

    const changePage = (page: CENSUS_DETAILS_PAGE) => setCurrentPage(page);
    const tabs: VeBoxTab [] = React.useMemo(() => {
        updateLastUserPosition({...lastUIUserPosition, detailPage: currentPage})
        return [
            {
                code: CENSUS_DETAILS_PAGE.SUMMARY,
                label: censusTranslations.censusDetailsSummaryTitle.toUpperCase(),
                isSelected: currentPage === CENSUS_DETAILS_PAGE.SUMMARY
            },
            {
                code: CENSUS_DETAILS_PAGE.EQUIPMENT,
                label: censusTranslations.censusDetailsEquipmentTitle.toUpperCase(),
                isSelected: currentPage === CENSUS_DETAILS_PAGE.EQUIPMENT
            }
        ]
    }, [currentPage]);


    React.useEffect(() => {
        delay(250).then(() =>
            setIsDrawerOpen(true))
    }, [])


    const toggleDrawer = () => setIsDrawerOpen(!isDrawerOpen);

    return (
        <div className={"flx-row fill-parent position-relative"}>
            <VeboxDrawer
                className={"side-menu details-menu"}
                header={<h1 className={"ellipsis"}>{censusTranslations.smallTitle}</h1>}
                defaultOpen={false}
                closable={true}
                open={isDrawerOpen}
                closedHeader={
                    <p className="closed-header-title">
                        {`${AppTranslations.massiveActions.censusCooler.title} ${getFormattedDate(
                            {dateToFormat: data?.createdAt})}`}
                    </p>
                }
            >
                <div className={"census-info-drawer"}>
                    <div className={"flx-row flx-end padding-right-10"}>
                        <CensusExport censusGuid={censusGuid}/>
                    </div>
                    <CensusLabelValue
                        valueClassName={"font-size-20 font-weight-400"}
                        labelClassName={"font-size-16"}
                        label={censusTranslations.createdAt}
                        value={getFormattedDate({dateToFormat: data?.createdAt})}
                    />
                    <CensusLabelValue
                        valueClassName={"font-size-20 font-weight-400"}
                        labelClassName={"font-size-16"}
                        label={censusTranslations.createdBy}
                        value={data?.username}
                    />
                    <CensusLabelValue
                        valueClassName={"font-size-20 font-weight-400"} labelClassName={"font-size-16"}
                        label={censusTranslations.startOfPeriod}
                        value={getFormattedDate({dateToFormat: data?.periodStart}) ?? "-"}
                    />
                    <CensusLabelValue
                        valueClassName={"font-size-20 font-weight-400"}
                        labelClassName={"font-size-16"}
                        label={censusTranslations.endOfPeriod}
                        value={getFormattedDate({dateToFormat: data?.periodEnd}) ?? "-"}
                    />
                </div>
            </VeboxDrawer>
            <div className={"census-details-content"}>
                <div className={"black-navbar"}>
                    <VeBoxBlackNavBar tabs={tabs} onSelect={changePage}/>
                </div>
                <Display isVisible={currentPage === CENSUS_DETAILS_PAGE.SUMMARY}>
                    <CensusCharts isLoadingData={isLoading} error={error}/>
                </Display>
                <Display isVisible={currentPage === CENSUS_DETAILS_PAGE.EQUIPMENT}>
                    <CensusFinalEquipmentList toggleDrawer={toggleDrawer}/>
                </Display>
            </div>
            <Outlet/>
        </div>
    )
}